<button class="btn ipm-learn-terms-btn" (click)="open()" type="button" title="Learn Terms">
    <i class="pi pi-info-circle"></i>
    <span class="btn-label" *ngIf="label">{{ label }}</span>
</button>

<!-- Combined metrics glossary — all metric definitions in one popup -->
<ng-template #metricsInfoPop let-data>
    <ipm-info-dialog [title]="data?.title" [icon]="data?.icon" [terms]="data?.terms"></ipm-info-dialog>
</ng-template>
